(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-copy"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
    const target = document.getElementById('conditional_in_view');
    const hideElement = document.getElementById('conditional_hide');

    if (target && hideElement) {
    window.addEventListener('scroll', function () {
    const targetRect = target.getBoundingClientRect(); // Get element position
    const isBelowViewport = targetRect.top > window.innerHeight; // Check if top is past bottom

    if (isBelowViewport) {
    $(hideElement).fadeIn();
    } else {
    $(hideElement).fadeOut(); // Hide when scrolled past the bottom
    // Show when scrolling back up
    }
    });
    }

    if (target && hideElement) {
    const targetRect = target.getBoundingClientRect(); // Get element position
    const isBelowViewport = targetRect.top > window.innerHeight; // Check if top is past bottom

    if (isBelowViewport) {
    $(hideElement).fadeIn();
    } else {
    $(hideElement).fadeOut(); // Hide when scrolled past the bottom
    // Show when scrolling back up
    }
    }
    });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-quick-buy"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
// Select all radio buttons
const radioButtons = document.querySelectorAll("input[type='radio']");

radioButtons.forEach((radio) => {
radio.addEventListener("click", function () {
const clickedId = this.id;
console.log(`Clicked Radio ID: ${clickedId}`);

// Extract the variant number from the ID
const variantMatch = clickedId.match(/-(\d+)$/);

if (variantMatch) {
const variantId = variantMatch[1];
console.log(`Extracted Variant ID: ${variantId}`);

// Find the corresponding radio button in the other group
const otherRadio = [...radioButtons].find((rb) => {
const rbVariantMatch = rb.id.match(/-(\d+)$/);
const rbVariantId = rbVariantMatch ? rbVariantMatch[1] : null;

return (
rb !== this &&
rbVariantId === variantId &&
!rb.checked
);
});

if (otherRadio) {
console.log(`Matching Radio Found: ${otherRadio.id}`);
otherRadio.checked = true;
otherRadio.dispatchEvent(new Event("change", { bubbles: true }));
} else {
console.log(`No matching unselected radio button found for variant ${variantId}`);
}
} else {
console.log("Could not extract variant ID from radio button ID.");
}
});
});
});






  } catch(e) { console.error(e); }
})();
})();
